import React, { useState, useEffect } from "react";
import { Box, Grid, Button, IconButton } from "@mui/material";
import CustomButton from "../../components/Button";
import CustomInput from "../../components/Input";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Colors } from "../../constants/Colors";
import { apiRequest } from "../../services/api-request";
import SelectPicker from "../../components/SelectPicker";
import CancelIcon from "@mui/icons-material/Cancel";
import AWS from "aws-sdk";
import { useAppContext } from "../../context/AppContext";

const AddEditUser = (props) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [saveEnabled, setSaveEnabled] = useState(false)
  const [imgs, setImgs] = useState('')
  const [data, setData] = useState()
  const { user } = useAppContext();

  const { currentState = {} } = props;

  const schema = yup
    .object({
      order_no: yup.string().required("Order No is required"),
      image: yup.string().required("Image is required"),
    })
    .required();

  const onSubmit = (data) => {
    data.preventDefault();
    const formData = new FormData(data.target);

    // if(Object.keys(currentState).length === 0) {

      let payload = {
        order_no: formData.get("order_no"),
        image: imgs,
      };

      let url = 'master/mithun-add-banners'

      apiRequest({
        url: url,
        data: payload,
        method: "POST",
      })
        .then((res) => {
          if (res?.success === false) {
            alert(res?.message);
          }
          if (res?.success === true) {
            alert(res?.message);
          }
          props.getUsersByType();
          props.onCancel();
      })
        .catch((err) => {
          console.log(err);
          alert(err?.response?.data?.message, "error");
      })
    // }
    // else {

    //   let payload = {
    //     user_id: currentState.user_id,
    //     mobile: formData.get("mobile"),
    //     name: formData.get("farmerName"),
    //     email: formData.get("email"),
    //   };

    //   apiRequest({
    //     url: `user/updateCompanyUser`,
    //     data: payload,
    //     method: "PUT",
    //   })
    //     .then((res) => {
    //       console.log(res, "RRRRRRRRRRRRRRRRRR");
    //       if (res?.success === false) {
    //         alert(res?.message);
    //       }
    //       if (res?.success === true) {
    //         alert(res?.message);
    //       }
    //       props.getUsersByType();
    //       props.onCancel();
    //   })
    //     .catch((err) => {
    //       console.log(err);
    //       alert(err?.response?.data?.message, "error");
    //   })

    // }

  };

  const { handleSubmit, control, watch } = useForm({
    resolver: yupResolver(schema),
  });

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      uploadFileToS3(file)
      setSelectedImage(URL.createObjectURL(file));
    }
  };

  const uploadFileToS3 = async (file) => {

    AWS.config.update({
      accessKeyId: process.env.REACT_APP_AccessKeyId,
      secretAccessKey: process.env.REACT_APP_SecretAccessKey,
      region: process.env.REACT_APP_Region,
    });

    const s3 = new AWS.S3();

    const bucketName = process.env.REACT_APP_BucketName;
    const key = file.name;

    const params = {
      Bucket: bucketName,
      Key: key,
      Body: file,
      ContentType: "image/jpeg",
    };

    try {
      const data = await s3.upload(params).promise();
      setImgs(data.Location)
      setSaveEnabled(true)
    } catch (error) {
      console.error("Error uploading image:", error);
      alert("Error uploading file. Please try again.");
    }
  };

  const handleCancelImage = () => {
    setSelectedImage(null);
    setImgs('');
    setSaveEnabled(false);
  };

  return (
    <>
      <Box sx={{ width: "100%", padding: "20px 0px 0px 0px" }}>
        <form onSubmit={onSubmit} autoComplete="off">
          <Grid
            container
            alignItems={"left"}
            justifyContent={"left"}
            width={"100%"}
            mb={"10px"}
            gap={3}
          >
            <Grid item xs={6}>
              <Controller
                name="order_no"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <CustomInput
                    {...field}
                    type={"number"}
                    inputLabel={"Enter Order No"}
                    error={!!error}
                    helperText={error ? error.message : ""}
                  />
                )}
              />
            </Grid>
          </Grid>
          <Grid
            container
            alignItems={"baseline"}
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          >
           <Grid item xs={12}>
              <Box>
                <Controller
                  name="image"
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <Box display="flex" flexDirection="column" gap={2}>
                      <input
                        type="file"
                        onChange={handleImageChange}
                        accept="image/*"
                        style={{ display: "none" }}
                        id="image-upload"
                      />
                      <label htmlFor="image-upload">
                        <Button variant="contained" component="span" style={{backgroundColor: "#B1040E"}}>
                          Upload Image
                        </Button>
                      </label>

                      {selectedImage ? (
                      <Box position="relative" display="inline-block" marginTop="10px">
                        <img
                          src={selectedImage}
                          alt="Selected"
                          style={{ width: "200px" }}
                        />
                        <IconButton
                          size="small"
                          onClick={handleCancelImage}
                          style={{
                            position: "absolute",
                            top: "-10px",
                            right: "-10px",
                            backgroundColor: "white",
                          }}
                        >
                          <CancelIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    ) : null}
                    </Box>
                  )}
                />
              </Box>
            </Grid>
          </Grid>

          <Grid
            container
            alignItems={"end"}
            justifyContent={"flex-end"}
            mt={2}
            gap={2}
          >
            <Grid item>
              <CustomButton
                title={`Cancel`}
                backgroundColor={Colors.white}
                textColor={Colors.headerColor}
                borderColor={Colors.headerColor}
                textFontSize={14}
                handleButtonClick={props?.onCancel}
                variant={"outlined"}
                width={130}
                height={34}
              />
            </Grid>
            {
              saveEnabled ?
              <Grid item>
                <CustomButton
                  variant={"contained"}
                  title={`Submit`}
                  backgroundColor={Colors.headerColor}
                  textColor={Colors.white}
                  borderColor={Colors.headerColor}
                  textFontSize={14}
                  type={"submit"}
                  width={130}
                  height={34}
                />
              </Grid> : null
            }
          </Grid>
        </form>
      </Box>
    </>
  );
};

export default AddEditUser;
